import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CoursePaymentListLayer from "../components/CoursePaymentLayer";
import SubscriptionPaymentLayer from "../components/SubscriptionPaymentLayer"


const SubscriptionPaymentListPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        {/* <Breadcrumb title="Users Grid" /> */}
        <div className="d-flex justify-content-between"><h5>Subscription Payments</h5><Breadcrumb title="Subscription Payments" /></div>
        {/* UsersListLayer */}
        <SubscriptionPaymentLayer/>
 
    </>
  );
};

export default SubscriptionPaymentListPage; 
